import {Database, useItemQuery} from '@tnc/shared';
import {Link} from 'react-router';

type ListingItemPropsT = {
  application: Database['public']['Tables']['Applications']['Row'];
  entityType: string;
};

function ApplicationItem({application, entityType}: ListingItemPropsT) {
  const {data: entity} = useItemQuery({
    table: entityType.charAt(0).toUpperCase() + entityType.slice(1),
    id: application.application_entity_id,
    idColumn: `${entityType}_id`,
  });

  return (
    <div key={application.application_entity_id} className="truncate">
      <div>
        <Link
          to={`/${entityType}s/${entity?.[`${entityType}_id`]}`}
          className="text-lg font-bold text-primary underline"
        >
          {entity?.[`${entityType}_name`]}
        </Link>
      </div>
      <div className="text-sm capitalize text-neutral-500">
        Edit | Delete | Status: {application?.application_status}
      </div>
    </div>
  );
}

export default ApplicationItem;
